import Feature from 'Services/Feature';

export default [
    {
        path: '/check-common-components',
        name: 'commonComponents',
        component: () => import('vcomponents/pages/CommonComponents.vue'),
        beforeEnter(to, from, next) {
            if (!Feature.isEnabled('check-common-components')) {
                next({ name: 'error.not.found' });
            } else {
                next();
            }
        },
    },
];
